/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

export type ShortUserApiResourceType = typeof ShortUserApiResourceType[keyof typeof ShortUserApiResourceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShortUserApiResourceType = {
  admin: 'admin',
  manager: 'manager',
  owner: 'owner',
  guest: 'guest',
  vendor: 'vendor',
  system: 'system',
} as const;
